/**
 * Message contract between the report-table worker and the UI.
 *
 * Rows are sent in batches as arrays-of-arrays (not objects) so the structured
 * clone stays cheap: 15k row objects with 46 string keys each would otherwise
 * cost more to clone than to parse.
 */

export type ReportTableRequest =
  | {
      type: "parse";
      /** Absolute URL of the report file (the static /report-resources path). */
      url: string;
      /** Rows per posted batch. */
      batchSize: number;
    }
  | { type: "cancel" };

export type ReportTableResponse =
  | { type: "columns"; columns: string[]; delimiter: string }
  | { type: "rows"; rows: string[][]; parsedRowCount: number }
  | { type: "done"; totalRows: number }
  | { type: "error"; message: string };

export const DEFAULT_BATCH_SIZE = 2000;
